<template lang="pug">
section
  v-container
    v-col.ma-auto.col-3
      v-form(v-model='valid' ref='form')
        v-text-field(label='Enter your username' v-model='form.username' :rules='usernameRules' required='')
        v-layout(justify-space-between='')
          v-btn(@click='submit' :class=" { 'blue darken-4 white--text' : valid, disabled: !valid }") Restore
          router-link(:to="{name: 'Signin'}") Signin
</template>
<script>
import {mapActions} from 'vuex'
  export default {
    data: () => ({
      form: {
        username: '',
      },
      valid: false,
      e1: true,
      usernameRules: [
        (v) => !!v || 'Password is required',
      ],
    }),
    methods: {
      ...mapActions('cognito', ['forgotPassword']),
      submit () {
        if (this.$refs.form.validate()) {
          this.forgotPassword({
            username: this.form.username,
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>